import InfoScreen from './InfoScreen';
import InputScreen from './InputScreen';
import ChoiceScreen from './ChoiceScreen';
import ConditionHandler from './ConditionHandler';

/**
 * Реестр компонентов по типу блока. Чтобы добавить новый тип блока,
 * достаточно создать компонент и зарегистрировать его здесь.
 *
 * Все компоненты принимают пропсы { block, variables, onNext }.
 * Для condition onNext(nextId); для остальных onNext(value, nextId, skip).
 */
export const blockRegistry = {
  info: InfoScreen,
  input: InputScreen,
  choice: ChoiceScreen,
  condition: ConditionHandler,
};
